export default __webpack_public_path__ + "static/media/logo-fantom.05a2b58d.svg";